<template>
  <div
    class="field-row-container"
    :class="{ 'field-row-container--border': !isLast }"
  >
    <div class="field-group-title">
      <span>if</span>
      <div class="mandatory-field-type">
        <span>{{fieldGroup.label}}</span>
      </div>

      <img
        class="right-arrow-icon"
        src="~@/assets/images/icons/annotation/rightArrow.svg"
        title="Arrow"
        width="12px"
        alt=""
      />
      <span class="text-xs">mandates</span>
    </div>

    <div v-if="selectedFieldsForGroup.length" class="selected-fields-wrapper">
      <div
        v-for="(item, index) in selectedFieldsForGroup"
        :key="index"
        class="selected-field"
      >
        <span>{{ item.label }}</span>

        <span
          v-if="!readOnly"
          @click="removeFieldSelection(item.value)"
          class="icon deselect-icon"
          :style="{
            WebkitMaskImage: `url(${require('@/assets/images/icons/close-icon.svg')})`,
            maskImage: `url(${require('@/assets/images/icons/close-icon.svg')})`,
          }"
          role="img"
          :aria-label="fieldGroup.label + ' icon'"
        />
      </div>
    </div>

    <div v-if="!readOnly" class="field-options-wrapper">
      <custom-multi-select
        :options="fieldOptions"
        :selected="selectedFieldIds"
        :enableSearch="false"
        use-external-trigger
        hide-select-box
        :dropdown-min-width="200"
        align-right
        :font-size="'var(--text-xs)'"
        @input="handleFieldSelection"
      >
        <template #trigger>
          <div class="add-field-button">
            <span
              v-tooltip="addFieldTooltip(fieldGroup.type)"
              class="icon"
              :style="{
                WebkitMaskImage: `url(${require('@/assets/images/icons/plus-icon.svg')})`,
                maskImage: `url(${require('@/assets/images/icons/plus-icon.svg')})`,
              }"
              role="img"
              :aria-label="fieldGroup.label + ' icon'"
            />
          </div>
        </template>
      </custom-multi-select>
    </div>
  </div>
</template>

<script>
import customMultiSelect from '@/components/common/customMultiSelect.vue'
import config from '@/config'

export default {
  name: 'mandatoryChecks',

  components: {
    customMultiSelect
  },

  props: {
    fieldGroup: {
      type: Object
    },
    selectedFields: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    handleFieldSelection (value) {
      const currentIds = this.selectedFieldIds

      if (JSON.stringify(currentIds) === JSON.stringify(value)) {
        return
      }

      this.$emit('update-fields', {
        type: this.fieldGroup.type,
        value
      })
    },
    removeFieldSelection (id) {
      const value = this.selectedFieldIds.filter(item => id !== item)

      this.$emit('update-fields', {
        type: this.fieldGroup.type,
        value
      })
    },

    addFieldTooltip () {
      return 'Add Required Field'
    }
  },

  computed: {
    fieldOptions () {
      return this.fieldGroup?.type === 'STANDARD_MATERIAL_FORM'
        ? (this.fieldGroup?.options || []).filter(item => item?.type !== config.FORM_TYPE.TABLE)
        : (this.fieldGroup?.options || [])
    },
    selectedFieldsForGroup () {
      return this.selectedFields
    },

    selectedFieldIds () {
      return this.selectedFields.map((field) => field.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.field-row-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--text-xs1);
  font-weight: 400;
  color: #696969;
  padding: 8px 10px;

  &--border {
    border-bottom: 1px solid #dfdede;
  }
}

.field-group-title {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: #c9a471;
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
}

.right-arrow-icon {
  display: inline-block;
  width: 12px;
  height: 10px;
}

.deselect-icon {
  width: 10px;
  height: 10px;
  cursor: pointer;

  &:hover {
    background-color: var(--alert);
  }
}

.add-field-button {
  padding: 4px;
  border-radius: 50%;
  background-color: var(--brand-light-color);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: var(--brand-color-2);
  }
}

.field-options-wrapper {
  display: flex;
  align-items: center;
}

.selected-fields-wrapper {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 10px;
  padding: 0 20px;
}

.selected-field {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #76612e;
  border: 1px solid var(--brand-color);
  background-color: var(--brand-light-color);
  border-radius: 50px;
  padding: 2px 10px;
  gap: 8px;
}

.mandatory-field-type {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #bb4d00;
  font-weight: 600;
  border: 1px solid var(--brand-color);
  background-color: var(--brand-light-color);
  border-radius: 50px;
  padding: 2px 10px;
  gap: 8px;
}
</style>
